import {defineNumberComponent} from '@z-elements/number';
import { define } from '@z-elements/reviews-stars';

define('z-reviews');
defineNumberComponent('z-number');
